module.exports = __webpack_public_path__ + "img/menucn_1_2.4ba222c4.svg";